import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/DatePickerComponent.css';
import { useApp } from '../context/appContext';
import { putAppointmentDates } from '../services/putAppointmentDates';
import { formatDate } from "../utils/lib";
import { putAppointmentDatetimes } from '../services/putAppointmentDatetimes';

const DatePickerComponent = ({ onLoading }) => {
  const { form, setForm } = useApp();
  const [selectedDate, setSelectedDate] = useState(form?.date || null);
  const [selectedTime, setSelectedTime] = useState(form?.time || null);
  const [dates, setDates] = useState([]); // Example dates
  const [timeSlots, setTimeSlots] = useState([]); // Example time slots
  // const [isLoading, setIsLoading] = useState(false); // Loading state for dates
  const [isLoadingTimes, setIsLoadingTimes] = useState(false); // Loading state for time slots

  const handleDateChange = (date) => {
    const formattedDate = formatDate(date);
    setSelectedDate(formattedDate);
    setForm({
      ...form,
      date: formattedDate
    });
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    setForm({
      ...form,
      time: time
    });
  };

  const fetchDatetimes = async (formattedDate) => {
    if (!form?.location?.Id || !form?.testId || !formattedDate) return;
    setIsLoadingTimes(true); // Show loading for time slots
    const appointmentDatetimes = await putAppointmentDatetimes(form?.location?.Id, form?.testId, formattedDate, form?.staffId);
    setTimeSlots(appointmentDatetimes);
    setIsLoadingTimes(false); // Hide loading after fetching
  };

  useEffect(() => {
    const fetchDates = async () => {
      if (!form?.location?.Id || !form?.testId) return;
      // setIsLoading(true); // Show loading during data fetch
      onLoading(true);
      const appointmentDates = await putAppointmentDates(form?.location?.Id, form?.testId, form?.staffId);
      // Sort the dates
      const sortedDates = appointmentDates.sort((a, b) => new Date(a) - new Date(b));
      setDates(sortedDates);
      handleDateChange(new Date(sortedDates[0]))
      onLoading(false);
      // setIsLoading(false); // Hide loading after data is fetched
    };

    if (form?.testId) {
      fetchDates();
    }
  }, [form?.location?.Id, form?.testId, form?.staffId]);

  // Fetch available times when selectedDate changes
  useEffect(() => {
    if (selectedDate) {
      fetchDatetimes(selectedDate);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  // Show nothing if form?.testId is undefined
  if (!form?.testId) {
    return null;
  }

  // Show loader while fetching dates
  // if (isLoading) {
  //   return (
  //     <div className="loader-container">
  //       <div className="loader"></div>
  //     </div>
  //   );
  // }

  // Show nothing if dates array is empty
  if (dates.length === 0) {
    return null;
  }
  
  return (
    <>
      <h3 className='date-picker-label'>Select your Appointment Date and Time <span style={{ color: 'red' }}>*</span></h3>
      <div className="date-picker-container">
        <div className="date-picker-component">
          {dates?.length > 0 && (
            <DatePicker
              minDate={new Date(dates[0])}
              maxDate={new Date(dates[dates.length - 1])}
              includeDates={dates?.map(date => new Date(date))}
              selected={selectedDate ? new Date(selectedDate) : null}
              selectsStart={false}
              onChange={(date) => handleDateChange(date)}
              inline
              calendarClassName="custom-calendar"
            />
          )}

          {/* Show loader while fetching time slots */}
          {isLoadingTimes ? (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            <div className="time-selector">
              {timeSlots?.length > 0 && timeSlots?.map((time) => (
                <button
                  key={time?.startTime}
                  className={selectedTime?.startTime === time?.startTime ? 'time-slot selected' : 'time-slot'}
                  onClick={() => handleTimeChange(time)}
                >
                  {selectedTime?.startTime === time?.startTime && (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="selected-icon"
                    >
                      <mask id="mask0_2_251" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2_251)">
                        <path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="white" />
                      </g>
                    </svg>
                  )}
                  {time?.startTimeReadable}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DatePickerComponent;
